export interface ComparativeAnalysisFilterValues {
  from: number;
  to: number;
  plate: string;
  weightFrom: number;
  weightTo: number;
  baseWim: string;
  intermediateWims: string[];
  endWim: string;
  isMoreThanBaseWeight: boolean;
  measurementFlags: string[] | string;
  laneIds: string[] | string;
  plateBack: string;
  plateRecognized: boolean;
  plateBackRecognized: boolean;
  vehicleClasses: string[];
  violationsTypesByOr: string[];
  axleCountFrom: number;
  axleCountTo: number;
  lengthFrom: number;
  lengthTo: number;
  widthFrom: number;
  widthTo: number;
  heightFrom: number;
  heightTo: number;
}

export interface Params extends ComparativeAnalysisFilterValues {
  format?: string;
}

export enum ComparativeAnalysisFilterKey {
  from = 'from',
  to = 'to',
  plate = 'plate',
  widthFrom = 'widthFrom',
  widthTo = 'widthTo',
  baseWim = 'baseWim',
  intermediateWims = 'intermediateWims',
  endWim = 'string',
  isMoreThanBaseWeight = 'boolean',
  vehicleClasses = 'vehicleClasses',
  plateRecognized = 'plateRecognized',
  plateBackRecognized = 'plateBackRecognized',
  axleCountFrom = 'axleCountFrom',
  axleCountTo = 'axleCountTo',
  lengthFrom = 'lengthFrom',
  lengthTo = 'lengthTo',
  weighFrom = 'weighFrom',
  weightTo = 'weightTo',
  heightFrom = 'heightFrom',
  heightTo = 'heightTo',
}
